import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import classes from '../../../pipeline.module.scss';
import Api from '../../../../../../../api/api';
import Table from '../../../../../../_common/Tables/Table';
import StatusField from '../../../../../../_common/StatusField/StatusField';
import { Card } from '../../PipelineComponents';
import { formattedDate } from '../../../pipelineHelpers';

const tableHeader = [
  { name: 'Member', path: 'name' },
  { name: 'LOB', path: 'lob' },
  { name: 'Source', path: 'source' },
  { name: 'Added', path: 'date' },
  {
    name: 'Reason',
    path: 'stuckReason',
  },
  { name: 'Follow-up', path: 'followUpDate' },
  { name: 'Outcome', path: 'finalOutcome' },
  {
    name: 'Status',
    path: 'status',
    render: (d) => (d.status ? <StatusField status={d.status} /> : '-'),
  },
];

const WaitingRxBoardCard = ({ params }) => {
  const navigate = useNavigate();

  const firstLoad = useRef(true);

  const [boardData, setBoardData] = useState([]);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getPipelineMembers(params);

        setBoardData((data?.data?.response || []).map((d) => ({
          ...d,
          id: d.PatientId || d.Patient?.id,
          name: [d.Patient?.firstName, d.Patient?.lastName].filter(Boolean).join(' '),
          date: formattedDate(d.date),
          followUpDate: formattedDate(d.followUpDate),
        })));

        loadingToggle(false);
        firstLoad.current = false;
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [params]);

  return (
    <Card
      title="Pipeline board"
      caption="Every open member, why they are stuck, and who owns the next step"
      loading={loading}
      firstLoad={firstLoad.current}
      isEmpty={!boardData.length}
    >
      <div className={classes.pipeline_table}>
        <Table
          header={tableHeader}
          data={boardData}
          className={classes.clickable_row}
          onClick={(patientId) => navigate(`/patients/${patientId}`)}
        />
      </div>
    </Card>
  );
};

WaitingRxBoardCard.propTypes = {
  params: PropTypes.object.isRequired,
};

export default WaitingRxBoardCard;
